import { render } from "./index.vue?vue&type=template&id=40775c5e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=40775c5e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/A01_brandsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40775c5e"]])

export default __exports__